import {Blankslate} from '@primer/react/experimental'

export interface CustomizeEmptyStateProps {
  heading: string
  description: string
  /** Matches the heading to its position in the surrounding outline. */
  headingLevel?: 'h2' | 'h3'
  /** Offers a retry, for the states that stand in for a failed read. */
  onRetry?: () => void
  retryLabel?: string
}

export function CustomizeEmptyState({
  heading,
  description,
  headingLevel = 'h3',
  onRetry,
  retryLabel = 'Try again',
}: CustomizeEmptyStateProps) {
  return (
    <Blankslate border spacious={false}>
      <Blankslate.Heading as={headingLevel}>{heading}</Blankslate.Heading>
      <Blankslate.Description>{description}</Blankslate.Description>
      {onRetry ? <Blankslate.PrimaryAction onClick={onRetry}>{retryLabel}</Blankslate.PrimaryAction> : null}
    </Blankslate>
  )
}
